import { useEffect } from "react";
import PropTypes from "prop-types";
import { parse } from "cookie";
import Dropdown from "../../../Dropdown";
import {
  redirectPage,
  getLocalStorageRoleState,
  initializeLocalStorageRoleState,
  updateLocalStorageRoleState,
} from "./utils";

const SelectRole = ({ selectedRole, setSelectedRole, roleOptions }) => {
  const { qpp_impersonated_user: isHelpdeskRoleAndImpersonating } = parse(
    document.cookie,
  );

  const handleSelection = (e) => {
    e.preventDefault();
    const dropdownValue = e.target.value;
    const newRoleSelected = roleOptions.filter(
      (opt) => opt.value === dropdownValue,
    )[0].value;
    // Update localStorage with the new role selected
    updateLocalStorageRoleState(newRoleSelected);
    setSelectedRole(newRoleSelected);
    redirectPage(newRoleSelected);
  };

  // Set role on init render
  // below is executed on every page refresh including on side nav link navigation & on role selection
  useEffect(() => {
    // Check localStorage & set initial selected role
    const { selectedUserRole } = getLocalStorageRoleState();
    const roleValue = selectedUserRole || roleOptions[0].value;

    // Set localStorage values if not set
    initializeLocalStorageRoleState(roleValue);

    // Update state
    setSelectedRole(roleValue);
    document.cookie = `selected_role=${roleValue}; Path=/;`;

    //Redirect to role default page IF localStorage was not set (indicates initial login)
    if (!selectedUserRole) {
      redirectPage(roleValue);
    }
  }, []);

  return (
    <div className="SelectRole__Container">
      <p className="SelectRole__Text">You are viewing as a</p>
      <Dropdown
        value={selectedRole}
        name="user-role-selection"
        ariaLabel="Select User Role"
        className="qpp-u-width--100 SelectRole__Dropdown"
        options={roleOptions}
        onChange={handleSelection}
        disabled={isHelpdeskRoleAndImpersonating}
      />
    </div>
  );
};

SelectRole.propTypes = {
  selectedRole: PropTypes.string,
  setSelectedRole: PropTypes.func,
  roleOptions: PropTypes.array,
};

export default SelectRole;
